import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 4) { toast.error("Password must be at least 4 characters"); return; }
    if (pw !== confirm) { toast.error("Passwords do not match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated! Log in with your new password.");
      navigate("/login");
    } catch (err) { toast.error(apiErr(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5 py-12">
      <div className="w-full max-w-md card-warm rounded-3xl p-8" data-testid="reset-form">
        <div className="text-center mb-6">
          <Logo className="h-20 mx-auto mb-3" />
          <h1 className="headline text-3xl text-[#f7f3ec]">Set New Password</h1>
          <p className="text-[#a9a196] text-sm">Choose a new password for your Ryder account</p>
        </div>
        {!token ? (
          <div className="text-center text-[#d6cec2]" data-testid="reset-no-token">
            <p>This reset link is missing or invalid. Please request a new one.</p>
            <Link to="/forgot-password" className="inline-block mt-6 btn-gold rounded-full px-6 py-3 font-display uppercase tracking-wide">Request New Link</Link>
          </div>
        ) : (
          <form onSubmit={submit}>
            <input value={pw} onChange={(e) => setPw(e.target.value)} type="password" required placeholder="New password" className="w-full bg-[#1a1816] border border-[#3a332c] rounded-xl px-4 py-3 mb-3 text-[#f7f3ec] placeholder:text-[#6b645b] focus:border-[#e0481f] outline-none" data-testid="reset-password" />
            <input value={confirm} onChange={(e) => setConfirm(e.target.value)} type="password" required placeholder="Confirm new password" className="w-full bg-[#1a1816] border border-[#3a332c] rounded-xl px-4 py-3 mb-5 text-[#f7f3ec] placeholder:text-[#6b645b] focus:border-[#e0481f] outline-none" data-testid="reset-confirm" />
            <button disabled={loading} className="w-full btn-ember rounded-full py-3.5 font-display uppercase tracking-wider flex items-center justify-center gap-2 disabled:opacity-60" data-testid="reset-submit">
              {loading ? <Loader2 className="animate-spin" size={18} /> : <KeyRound size={18} />} Update Password
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
